export default __webpack_public_path__ + "static/media/amad.36ce15c5.png";